
<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('lifeCycleDelete') }}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                </div>
                <div class="modal-body">
                    <template v-if="this.$parent.foundLifeCycles.length > 0">
                        <label class="form-label">{{ $t('cannotDeleteLifeCycle') }}</label>
                        <div v-for="(lifeCycle, i) in this.$parent.foundLifeCycles" :key="i">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/selection/' + lifeCycle.selectionId + '/package/' + lifeCycle.selectionPackageId ">
                                {{ lifeCycle.name }}
                            </RouterLink>
                        </div>
                    </template>
                    <p v-else>{{ $t('wannaDeleteThisLifeCycle') }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="deleteLifeCycle" :disabled="this.$parent.foundLifeCycles.length > 0">
                        {{ $t('delete') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import LifeCycleApi from "../../api/server/lifeCycle";

export default {
    name: "lifeCycleDeleteModal",
    methods: {
        close() {
            this.$emit("closeDeleteDialog");
        },
        async deleteLifeCycle() {
            await LifeCycleApi.lifeCycleDelete(this.$parent.$route.params.id, this.$parent.lifeCycleToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        },
    }
};
</script>